<app-breadcrumb></app-breadcrumb>
<div class="api-client">
  <!-- Request Builder -->
  <div class="request-card">
    <div class="request-row">
      <select [(ngModel)]="method" class="method-select">
        <option>GET</option>
        <option>POST</option>
        <option>PUT</option>
        <option>DELETE</option>
        <option>PATCH</option>
      </select>
      <input [(ngModel)]="url" class="url-input" placeholder="Enter request URL" />
      <button class="import-btn" (click)="openCurlImport()">Import cURL</button>
      <button class="send-btn" (click)="sendRequest()">Send</button>
    </div>

    <!-- Query Params -->
    <div class="section">
      <h4>Query Params</h4>
      @for (param of queryParams; track param; let i = $index) {
        <div class="row">
          <input [(ngModel)]="param.key" placeholder="Key" />
          <input [(ngModel)]="param.value" placeholder="Value" />
          <button class="remove-btn" (click)="removeQueryParam(i)">x</button>
        </div>
      }
      <button class="add-btn" (click)="addQueryParam()">+ Add Param</button>
    </div>

    <!-- Headers -->
    <div class="section">
      <h4>Headers</h4>
      @for (header of headers; track header; let i = $index) {
        <div class="row">
          <!-- Custom Autocomplete -->
          <div class="autocomplete">
            <input [(ngModel)]="header.key" (input)="filterSuggestions(header)" placeholder="Key" class="input" />
            @if (header.showSuggestions) {
              <ul class="suggestion-list">
                @for (suggestion of header.filteredSuggestions; track suggestion) {
                  <li (click)="selectSuggestion(header, suggestion)">
                    {{ suggestion }}
                  </li>
                }
              </ul>
            }
          </div>
          <input [(ngModel)]="header.value" placeholder="Value" class="input" />
          <button (click)="removeHeader(i)" class="remove-btn">x</button>
        </div>
      }

      <button class="add-btn" (click)="addHeader()">+ Add Header</button>
    </div>


    <!-- Body -->
    @if (method !== 'GET' && method !== 'DELETE') {
      <div class="section">
        <h4>Body</h4>
        <!-- Body Type Tabs -->
        <div class="body-tabs">
          @for (type of bodyTypes; track type) {
            <button [class.active]="bodyType === type" (click)="bodyType = type">
              {{ type }}
            </button>
          }
        </div>
        <!-- None -->
        @if (bodyType === 'none') {
          <div class="body-none">
            <p>No body will be sent with this request.</p>
          </div>
        }
        <!-- Raw -->
        @if (bodyType === 'raw') {
          <div>
            <select [(ngModel)]="rawBodyType" class="raw-select">
              <option>JSON</option>
              <option>Text</option>
              <option>HTML</option>
              <option>XML</option>
            </select>
            <textarea [(ngModel)]="body" class="body-textarea" rows="8" [placeholder]="getRawPlaceholder()"></textarea>
          </div>
        }
        <!-- Form-Data -->
        @if (bodyType === 'form-data') {
          <div>
            @for (field of formData; track field; let i = $index) {
              <div class="row">
                <input [(ngModel)]="field.key" placeholder="Key" />
                <input [(ngModel)]="field.value" placeholder="Value" />
                <select [(ngModel)]="field.type">
                  <option value="text">Text</option>
                  <option value="file">File</option>
                </select>
                <button class="remove-btn" (click)="removeFormData(i)">x</button>
              </div>
            }
            <button class="add-btn" (click)="addFormData()">+ Add Field</button>
          </div>
        }
        <!-- x-www-form-urlencoded -->
        @if (bodyType === 'x-www-form-urlencoded') {
          <div>
            @for (param of urlEncoded; track param; let i = $index) {
              <div class="row">
                <input [(ngModel)]="param.key" placeholder="Key" />
                <input [(ngModel)]="param.value" placeholder="Value" />
                <button class="remove-btn" (click)="removeUrlEncoded(i)">x</button>
              </div>
            }
            <button class="add-btn" (click)="addUrlEncoded()">+ Add Param</button>
          </div>
        }
        <!-- Binary -->
        @if (bodyType === 'binary') {
          <div>
            <input type="file" (change)="onBinaryFileSelected($event)" />
            @if (binaryFile) {
              <p>Selected: {{ binaryFile.name }}</p>
            }
          </div>
        }
        <!-- GraphQL -->
        @if (bodyType === 'GraphQL') {
          <div>
            <textarea [(ngModel)]="graphqlQuery" class="body-textarea" rows="6"
            placeholder="Enter GraphQL query"></textarea>
            <textarea [(ngModel)]="graphqlVariables" class="body-textarea" rows="4"
            placeholder="Variables (JSON)"></textarea>
          </div>
        }
      </div>
    }

  </div>

  <!-- Import Modal -->
  @if (showCurlModal) {
    <div class="curl-modal">
      <div class="modal-content">
        <h4>Paste your cURL command</h4>
        <textarea [(ngModel)]="curlInput" rows="6" placeholder="Paste cURL here"></textarea>
        <div class="modal-actions">
          <button class="modal-btn" (click)="parseCurl()">Import</button>
          <button class="modal-btn" (click)="closeCurlImport()">Cancel</button>
        </div>
      </div>
    </div>
  }

  <!-- Response -->
  @if (response) {
    <div class="response-card">
      <h4>Response</h4>
      <!-- Attribute selector -->
      <div class="attribute-selector">
        <!-- Left side: label + dropdown -->
        <div class="left-controls">
          <label for="responseKey">Select Output: </label>
          <select id="responseKey" [(ngModel)]="selectedAttribute" (change)="updateSelectedAttribute()">
            <option value="">Entire Response</option>
            @for (key of (response | keys); track key) {
              <option [value]="key">{{ key }}</option>
            }
          </select>
        </div>
        <!-- Right side: Clear button -->
        <div>
          <!-- Select Map Config Dropdown -->
          <select [(ngModel)]="selectedMappingId" class="module-dropdown">
            <option value="" disabled>Select Map Config</option>
            @for (map of allMappings; track map) {
              <option [value]="map.id">
                {{ map.name }}
              </option>
            }
          </select>
          <!-- Module Dropdown -->
          <select [(ngModel)]="selectedModule" class="module-dropdown">
            <option value="" disabled>Select Module</option>
            <option value="course">Course</option>
            <option value="questionPaper">Question Paper</option>
            <option value="assessment">Assessment</option>
          </select>
          <button class="send-btn sync-btn" (click)="syncNow()">Sync Now</button>
          <button class="clear-btn" (click)="clearAll()">Clear All</button>
        </div>
      </div>
      <!-- <div *ngIf="isArray">
      <div class="table-container">
        <table>
          <thead>
            <tr>
              <th>
                <input type="checkbox" (change)="toggleSelectAllAcrossPages()" [checked]="selectAllAcrossPages" />
              </th>
              <th *ngFor="let col of (paginatedData[0] ? (paginatedData[0] | keys) : [])">
                {{ col }}
              </th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let row of paginatedData; let i = index">
              <td>
                <input type="checkbox" (change)="toggleSelect(i)" [checked]="selected.has((currentPage-1)*pageSize+i)" />
              </td>
              <td *ngFor="let col of (row | keys)">
                {{ row[col] }}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="pagination">
        <button (click)="prevPage()" [disabled]="currentPage===1">«</button>
        <ng-container *ngFor="let page of getPageNumbers()">
          <button *ngIf="page !== '...'; else dots" (click)="goToPage(page)" [class.active]="currentPage === page">
            {{ page }}
          </button>
          <ng-template #dots>
            <span class="dots">...</span>
          </ng-template>
        </ng-container>
        <button (click)="nextPage()" [disabled]="currentPage===totalPages">»</button>
      </div>
    </div> -->
    <pre class="response-json">{{ dataToRender | json }}</pre>
  </div>
}

</div>